import c from "./defineProperty.js";
function o(t, n) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    n && (r = r.filter(function(p) {
      return Object.getOwnPropertyDescriptor(t, p).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function f(t) {
  for (var n = 1; n < arguments.length; n++) {
    var e = arguments[n] != null ? arguments[n] : {};
    n % 2 ? o(Object(e), !0).forEach(function(r) {
      c(t, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : o(Object(e)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return t;
}
export {
  f as default
};
//# sourceMappingURL=objectSpread2.js.map
